export enum PackageVariant {
  Single = "singleReport",
  Advanced = "advanced",
  Professional = "professional",
  B2BSmall = "b2bSmall",
  B2BMedium = "b2bMedium",
  B2BLarge = "b2bLarge",
  B2BNetSmall = "b2bNetSmall",
  B2BNetMedium = "b2bNetMedium",
  B2BNetLarge = "b2bNetLarge",
}
